import VideoPopup from "./VideoPopup";

function CaseStudyItems(){

	this.init  = () => {
		jQuery('[data-dropdown-header]').on('click', this.handleDropdownHeaderClick);
		jQuery('[data-link-type=video]').on('click', this.handleVideoLinkClick);
	}

	this.handleVideoLinkClick = (ev) => {
		ev.preventDefault();
		const $link = jQuery(ev.target);
		VideoPopup.open($link.attr('href'), $link.data('link-title'));
	}

	this.handleDropdownHeaderClick = (ev) => {
		ev.preventDefault();
		const $dropdownHeader = jQuery(ev.target);
		const $dropdown = $dropdownHeader.closest('[data-dropdown]');
		const dropdownType = $dropdown.data('dropdown');
		const $dropdownBody = $dropdown.find('[data-dropdown-body]');
		const $caseStudyItem = $dropdown.closest('[data-case-study-item]');
		const dropdownBodyHeight = $dropdownBody.get(0).scrollHeight;
		const isExpanded = $dropdown.hasClass('expanded');
		$dropdownBody.css({
			height: isExpanded ? 0 : `${dropdownBodyHeight}px`
		});
		$dropdown.toggleClass('expanded', !isExpanded);
		$caseStudyItem.toggleClass(`case-studies__item--${dropdownType}`, !isExpanded);
	}

}
export default new CaseStudyItems();
